import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CsrfService {
  private http = inject(HttpClient);
  private primed$: Observable<void> | null = null;
  private hostUrl = environment.apiBaseUrl.replace('api/v1', '');
  ensure(force = false): Observable<void> {
    // If we want to force a refresh, clear the cached observable
    if (force) {
      this.primed$ = null;
    }

    // If we haven't fetched it yet (or just cleared it), make the request
    if (!this.primed$) {
      this.primed$ = this.http
        .get(`${this.hostUrl}sanctum/csrf-cookie`, {
          withCredentials: true,
          responseType: 'text',
        })
        .pipe(
          map(() => void 0),
          shareReplay(1) // Prevents multiple simultaneous requests
        );
    }

    return this.primed$;
  }
}
